module.exports = __webpack_public_path__ + "static/media/logo_cadillac.4eac2a70.png";